(ns iris.utils
  (:require
   [clojure.string :as string]
   [goog.i18n.DateTimeFormat :as dtf]
   [iris.globals :as globals]))

(defn clj->json
  [ds]
  (.stringify js/JSON (clj->js ds)))

(defn map-kv [f coll]
  (reduce-kv (fn [m k v] (assoc m k (f v))) (empty coll) coll))

(defn parse-params
  "Parse URL parameters into a hashmap"
  []
  (let [param-strs (-> (.-location js/window) (string/split #"\?") last (string/split #"\&"))]
    (into {} (for [[k v] (map #(string/split % #"=") param-strs)]
               [(keyword k) v]))))

(defn is-input-checked [id]
  (.-checked (.querySelector js/document id)))


(def days ["Sunday" "Monday" "Tuesday" "Wednesday" "Thursday" "Friday" "Saturday"])

(def months ["January" "February" "March" "April" "May" "June" "July" "August"
             "September" "October" "November" "December"])

;; (defn get-month-from-utc-date
;;   ([dt] (get-month-from-utc-date dt false))
;;   ([dt short]
;;    (let [D (new js/Date dt)
;;          m (.getUTCMonth D)]
;;      (if (true? short) (subs (nth months m) 0 3) (nth months m)))))

;; (defn get-date-from-utc-date [dt]
;;   (let [D (new js/Date dt)]
;;     (.getUTCDate D)))

(defn get-day-from-utc-date
  ([dt] get-day-from-utc-date dt false)
  ([dt short]
  ;;  (println dt short)
   (let [D (new js/Date dt)
        ;;  d (- (.getUTCDay D) 1)
         d (.getUTCDay D)
         ]
    ;;  (println D d)
     (if (true? short) (subs (nth days d) 0 3) (nth days d)))))


(defn dt2ago
  ([dt] (dt2ago dt false nil))
  ([dt short] (dt2ago dt short nil))
  ([dt short shorts]
   (let [now (.now js/Date)
        ;;  ms (.parse js/Date dt)
         DT (new js/Date dt)
         ms (.getTime DT)
         delta (- now ms)
         m (.getUTCMonth DT)
         d (.getUTCDate DT)
         y (.getUTCFullYear DT)
         y-now (.getUTCFullYear (new js/Date))

         seconds-ago (int (/ delta 1000))
         minutes-ago (int (/ seconds-ago 60))
         hours-ago (int (/ minutes-ago 60))
         days-ago (int (/ hours-ago 24))
         months-ago (int (/ days-ago 30))
         years-ago (int (/ months-ago 12))

         is-short? #(or (true? short) (% shorts))]

     (cond (< seconds-ago 0) ""
           (= minutes-ago 0) (if (is-short? :seconds) "0m ago" "just now")
           (= hours-ago 0) (cond (is-short? :minutes) (str minutes-ago "m ago")
                                 (= minutes-ago 1) (str minutes-ago " minute ago")
                                 :else (str minutes-ago " minutes ago"))
           (= days-ago 0) (cond (is-short? :hours) (str hours-ago "h ago")
                                (= hours-ago 1) (str hours-ago " hour ago")
                                :else (str hours-ago " hours ago"))
           (= months-ago 0) (cond (is-short? :days) (str days-ago "d ago")
                                  (= days-ago 1) (str days-ago " day ago")
                                  :else (str days-ago " days ago"))
           (and (= years-ago 0) (= y-now y)) (if (is-short? :months)
                                               (str (subs (nth months m) 0 3) " " d)
                                               (str (nth months m) " " d))
           ;; years_ago > 0
           :else (if (is-short? :months)
                   (str (subs (nth months m) 0 3) " " d ", " y)
                   (str (nth months m) " " d ", " y))))))




(defn copy-to-clipboard [val]
  (let [el (js/document.createElement "textarea")]
    (set! (.-value el) val)
    (.appendChild js/document.body el)
    (.select el)
    (js/document.execCommand "copy")
    (.removeChild js/document.body el)))

;; transducer condj
;; reducing function that ignores nil
;; user=> (condj [3 4 5] 9)
;; [3 4 5 9]
;; user=> (condj [3 4 5] nil)
;; [3 4 5]
;; user=> (condj [3 4 5] false)
;; [3 4 5 false]
;; https://stackoverflow.com/a/59804676
(def condj ((remove nil?) conj))


;; https://stackoverflow.com/a/9745663
(defn params->query-string [m]
  (clojure.string/join "&" (for [[k v] m] (str (name k) "=" v))))






;; (defn get-jwt []
;;   (cookie/get-cookie "jwt"))

;; (defn get-fbjwt []
;;   (b64/decodeString (cookie/get-cookie "fbjwt")))


;; (defn jwt-valid? [jwt]
;;   ;; (if-let [jwt (cookie/get-cookie "jwt")]
;;     (let [payload (js->clj (.parse js/JSON (b64/decodeString (second (str/split jwt #"\.")))) :keywordize-keys true)
;;           exp (* (:exp payload) 1000)
;;           now (.now js/Date)]
;;       (println (- exp now))
;;       (if (> (- exp now) 0) true false))
;;     ;; false)
;;   )


;; (defn fbjwt-valid? [jwt]
;;   ;; (if-let [jwt (cookie/get-cookie "fbjwt")]
;;     (let [payload (js->clj (.parse js/JSON (b64/decodeString (second (str/split jwt #"\.")))) :keywordize-keys true)
;;           exp (* (:exp payload) 1000)
;;           now (.now js/Date)]
;;       (println "fbjt payload::" payload)
;;       (println (- exp now))
;;       (if (> (- exp now) 0) true false))
;;     ;; false)
;;   )


;; (defn logged-in? []
;;   (when-let [jwt (get-jwt)]
;;     (when (jwt-valid? jwt)
;;       (when-let [fbjwt (get-fbjwt)]
;;         (when-not (fbjwt-valid? fbjwt)
;;           (re-frame/dispatch [::login-events/get-firebase-jwt jwt])))
;;       true)))



(defn format-date
  [date-format date]
;; https://github.com/google/closure-library/blob/master/closure/goog/i18n/datetimeformat.js#L16
;; https://unicode-org.github.io/icu/userguide/format_parse/datetime/#date-field-symbol-tabl
  (.format (goog.i18n.DateTimeFormat.
            date-format)
           (js/Date. date) globals/GOOG_I18N_TIMEZONE_UTC))


;; 07/18/2024 deprecated, now using compass global js vars instead
;; (defn get-tiern-domain []
;;   (let [hostname (.. js/window -location -hostname)]
;;     (cond (= hostname "localhost")
;;           {:tiern nil :domain "rkdev.org"}
;;           (= hostname "iris.ipad.org")
;;           {:tiern nil :domain "ipad.org"}
;;           (= hostname "preprod.iris.ipad.org")
;;           ;; {:tiern nil :domain "ipad.org"}
;;           {:tiern nil :domain "preprod.iris.ipad.org"}
;;           :else
;;           (let [host-parts (str/split hostname #"\.")
;;                 sub (nth host-parts 0) ;; iris
;;                 sld (nth host-parts 1) ;; rktest
;;                 tld (nth host-parts 2) ;; org
;;                 subn (re-find #"\d+" sub)] ;; 2 (as in iris2)
;;             {:tiern subn :domain (str sld "." tld)}))))

;; (defn get-service-url
;;   ([service]
;;    (get-service-url service nil))
;;   ([service path]
;;    (let [tnd (get-tiern-domain)]
;;      (str "https://" service (:tiern tnd) "." (:domain tnd) path))))



;; 07/18/2024: deprecated, use compass global js vars instead (js/apolloURL, js/hermesURL, etc.)
;; (defn get-service-url [service]
;;   (let [tnd (get-tiern-domain)]
;;     ;; (str "https://" service (:tiern tnd) "." (:domain tnd))
;;     ;; temp solution for calling "apollo" from 'iris.rktest.org' - use apollo2.rktest.org
;;     ;; (if (and (= service "apollo") (= (:domain tnd) "rktest.org"))
;;     ;;   "https://apollo2.rktest.org"
;;     ;;   (str "https://" service (:tiern tnd) "." (:domain tnd)))
;;     ;; also, temporarily calling preprod from prod
;;     (cond (and (= service "aut") (= (:domain tnd) "rkdev.org"))
;;           "https://aut.rkdev.org"
;;           ;; (and (= service "apollo") (= (:domain tnd) "rktest.org"))
;;           ;; "https://apollo2.rktest.org"
;;           ;; (and (= service "apollo") (= (:domain tnd) "ipad.org"))
;;           ;; "https://preprod.apollo.ipad.org"
;;           ;; remove this - start:
;;           ;; (and (= service "apollo") (= (:domain tnd) "rkdev.org"))
;;           ;; "https://apollo2.rkdev.org"
;;           ;; remove this end
;;           (and (= service "aut") (= (:domain tnd) "preprod.iris.ipad.org"))
;;           "https://aut.ipad.org"
;;           (and (= service "apollo") (= (:domain tnd) "preprod.iris.ipad.org"))
;;           "https://preprod.apollo.ipad.org"
;;           :else
;;           (str "https://" service (:tiern tnd) "." (:domain tnd)))))


(defn get-analytics-service-url []
  ;; Temporarily use the deployed analytics API while the local API is unavailable.
  "https://analyticsapi-tket7oepsq-uc.a.run.app/")


;; 07/18/2024 deprecated, use js/athenaBaseURL instead
;; (defn get-athena-url []
;;   (let [env (:env @globals/jwt-payload)
;;         domain (cond (or (= env "dev") (= env "test"))
;;                      (str "athena.rk" env ".org")
;;                      (= env "preprod")
;;                      "preprod.athena.ipad.org"
;;                      (= env "prod")
;;                      "athena.ipad.org")]
;;     (str "https://" domain)))


(defn auto-grow-element [el]
  (set! (.. el -style -height) "5px")
  (set! (.. el -style -height) (str (.-scrollHeight el) "px")))


(defn iOS13+iPad []
  (and (js/navigator.userAgent.includes "Mac")
       (or (exists? js/document.ontouchend)
           (and (exists? js/navigator.maxTouchPoints)
                (> js/navigator.maxTouchPoints 0)))))


(defn truncate [s n]
  (if (> (count s) n)
    (let [p (string/split s " ")]
      (loop [ns ""
             np p]
        (let [cs (str ns " " (first np))]
          (if (< (count cs) n)
            (recur cs (rest np))
            (str ns "...")))))
    s))


(defn find-first-matching-key [data target-keys]
  (letfn [(search [x]
            (cond
              ;; If x is a map, look for a direct match or recurse into values
              (map? x)
              (or (some (fn [k]
                          (when (contains? x k)
                            [k (get x k)]))
                        target-keys)
                  (some search (vals x)))

              ;; If x is sequential, search each item
              (sequential? x)
              (some search x)

              ;; Otherwise ignore
              :else nil))]
    (search data)))



;; Extracts ws and forum from ruid, if found, replaces "/" with ":"
;; (extract-forum-and-website "/c/aamco.TSC")
;; => {:forum "c:aamco", :website "TSC"}
(defn extract-forum-and-website [input]
  (when (and (string? input)
             (.startsWith input "/"))
    (let [path (subs input 1)
          last-dot-index (.lastIndexOf path ".")]
      (when (not= last-dot-index -1)
        (let [forum-part (subs path 0 last-dot-index)
              website (subs path (inc last-dot-index))
              forum (if (.includes forum-part "/")
                      (.replace forum-part "/" ":")
                      forum-part)]
          {:forum forum
           :website website})))))


(defn strip-html [html]
  (let [parser (js/DOMParser.)
        doc (.parseFromString parser html "text/html")]
    (.-textContent (.-body doc))))
